import React from "react";

export const sentences = [
    { id: 1,
      quote: "I know this defies the law of gravity, but, you see, I never studied law. " ,
      title: "Bugs Bunny",
      video: "https://www.youtube.com/watch?v=3PzY_ro13UE"},
    { id: 2,
      quote: "If an interesting monster can't have an interesting hairdo I don't know what this world is coming to." ,
      title: "Bugs Bunny",
      video: "https://www.youtube.com/embed/J4fjA8W-6es?start=20&end=27"},
    { id: 3,
      quote: "I'm normally not a praying man, but if you're up there, please save me Superman. " ,
      title: "Simpsons",
      video: "https://www.youtube.com/watch?v=Ft7wEehEMdo"},
    { id: 4,
      quote: "Nobody exists on purpose. Nobody belongs anywhere. We're all going to die. Come watch TV." ,
      title: "Rick and Morty",
      video: "https://youtu.be/E_qvy82U4RE?t=51s"},
    { id: 5,
      quote: "Doughnuts? I told you I don’t like ethnic food " ,
      title: "Simpsons",
      video: "https://www.youtube.com/embed/UpZp6vfyA-8?start=37&end=41"},
    { id: 6,
      quote: "Look at that, Abu! It’s not every day you see a horse with two rear ends. " ,
      title: "Alladin",
      video: "https://www.youtube.com/embed/qPGfbSuJNwQ?start=28&end=33"},
    { id: 7,
      quote: "What do you want me to do, dress in drag and do the hula? " ,
      title: "Lion King",
      video: "https://www.youtube.com/embed/Etkws_5mexg?start=2&end=5"},
    { id: 8,
      quote: "Hey cutie! Wanna pollinate with a real bug? " ,
      title: "A bug's life",
      video: "https://www.youtube.com/embed/vklQ_VbmufI?start=2&end=6"},
    { id: 9,
      quote: "We didn’t set out to be superheroes. But sometimes life doesn’t go the way you planned. " ,
      title: "Big Hero 6",
      video: "https://youtu.be/Qae_RxoKjHA?t=280"},
    { id: 10,
      quote: "Of course I like you. It's because I like you, I don't want to be with you. It's a complicated emotion." ,
      title: "Nemo",
      video: "https://youtu.be/s5cGwymC_q0?t=1"},
    { id: 11,
      quote: "Just wait over there and forget. That is what you do best " ,
      title: "Nemo",
      video: "https://getyarn.io/yarn-clip/2a9e7e59-469e-4c13-a02a-9fcccd8fbffe"},
    { id: 12,
      quote: "if you take away our cartoons, we'll grow up without a sense of humor and be robots." ,
      title: "Simpsons",
      video: ""},
    { id: 13,
      quote: "Eating greens is a special treat. It makes long ears and great big feet. But it sure is awful stuff to eat. I made that last part up myself. " ,
      title: "Thumper ",
      video: "https://youtu.be/xDjkmUsPMcc?t=3"},
    { id: 14,
      quote: "Ohana means family. And family means nobody gets left behind or forgotten. " ,
      title: "Lilo & Stitch",
      video: "https://youtu.be/U37cChUfHk0?t=11"},
    { id: 15,
      quote: "I promise. And when I promise something, I never, ever, break that promise. " ,
      title: "Tangled",
      video: "https://youtu.be/kmAmPmE4ABc?t=139"},
    { id: 16,
      quote: "A true hero isn't measured by the size of his strength, but by the strength of his heart." ,
      title: "Hercules",
      video: "https://youtu.be/6xhZ0KE7mS4?t=50"},
    { id: 17,
      quote: "If only I could make him understand. I just don't see things the way he does. I just don't see how a world that makes such wonderful things could be bad. " ,
      title: "The little Mermaid",
      video: "https://youtu.be/2BZp2dxpwF8?t=3"},
    { id: 18,
      quote: "Faith. You can’t touch it or buy it or wrap it up tight, but it’s there just the same, making things turn out right. " ,
      title: "The Rescuers",
      video: "https://youtu.be/IM4V2bf4DfM?t=104"},
    { id: 19,
      quote: "The second star to the right shines in the night for you, to tell you that the dreams you plan really can come true. " ,
      title: "Peter Pan",
      video: "https://youtu.be/uYhFVfkfujs?t=195"},
    { id: 20,
      quote: "The past can hurt, but the way I see it, you can either run from it or learn from it. " ,
      title: "LIon King",
      video: "https://youtu.be/dZfGTL2PY3E?t=32"},
    { id: 21,
      quote: "They may take our lives, but they'll never take our freedom " ,
      title: "Braveheart",
      video: "https://www.youtube.com/watch?v=0zFAvzf0Mv0"},
    { id: 22,
      quote: "When you realize you want to spend the rest of your life with somebody, you want the rest of your life to start as soon as possible " ,
      title: "When Harry met Sally",
      video: "https://youtu.be/2q1-X6CnN-I?t=23"},
    { id: 23,
      quote: "If you let my daughter go now, that'll be the end of it. I will not look for you, I will not pursue you. But if you don't, I will look for you, I will find you, and I will kill you " ,
      title: "Taken",
      video: "https://youtu.be/KgmO32IdwuE?t=24"},
    { id: 24,
      quote: "Get your stinking paws off me, you damned dirty ape " ,
      title: "Planet of the Apes",
      video: "https://www.youtube.com/watch?v=Cdmqn9JIuzc"},
    { id: 25,
      quote: "Badges? We ain't got no badges! We don't need no badges! I don't have to show you any stinking badges " ,
      title: "The Treasure of Sierra Madre",
      video: "https://youtu.be/VqomZQMZQCQ?t=11"},
    { id: 26,
      quote: "Gentlemen, you can't fight in here! This is the war room " ,
      title: "Dr. Strangelove",
      video: "https://youtu.be/UAeqVGP-GPM?t=34"},
    { id: 27,
      quote: "I have always depended on the kindness of strangers " ,
      title: "A streetcar named desire",
      video: "https://youtu.be/DSTd1LuiVUs?t=12"},
    { id: 28,
      quote: "You know how to whistle, don't you, Steve? You just put your lips together and blow." ,
      title: "",
      video: "https://youtu.be/30DSfAA0brs?t=78"},
    { id: 29,
      quote: "I am big! It's the pictures that got small" ,
      title: "",
      video: "https://www.youtube.com/watch?v=yCV3SaF2NfQ"},
    { id: 30,
      quote: "Every time a bell rings, an angel gets his wings" ,
      title: "",
      video: "https://www.youtube.com/watch?v=3NX4l6jAzFA"},
    { id: 31,
      quote: " Keep your friends close, but your enemies closer" ,
      title: "",
      video: "https://www.youtube.com/watch?v=DfHJDLoGInM"},
    { id: 32,
      quote: "The greatest trick the devil ever pulled was convincing the world he didn't exist" ,
      title: "",
      video: "https://www.youtube.com/watch?v=KnGo6Qm0Wt8"},
    { id: 33,
      quote: "I'm as mad as hell, and I'm not going to take this anymore" ,
      title: "",
      video: "https://www.youtube.com/watch?v=rGIY5Vyj4YM"},
    { id: 34,
      quote: "You don't understand! I could've had class. I could've been a contender. I could've been somebody, instead of a bum, which is what I am" ,
      title: "",
      video: "https://www.youtube.com/watch?v=efHzGxEzDQA"},
    { id: 35,
      quote: "Fasten your seatbelts. It's going to be a bumpy night" ,
      title: "",
      video: "https://www.youtube.com/watch?v=LPPJdOGshUM"},
    { id: 36,
      quote: "You've got to ask yourself one question, 'Do I feel lucky?' Well, do ya punk?" ,
      title: "",
      video: "https://www.youtube.com/watch?v=38mE6ba3qj8"},
    { id: 37,
      quote: "Say hello to my little friend" ,
      title: "",
      video: "https://www.youtube.com/watch?v=AVQ8byG2mY8"},
    { id: 38,
      quote: "Mrs. Robinson, you're trying to seduce me, aren't you? " ,
      title: "",
      video: "https://www.youtube.com/watch?v=-3lKbMBab18?start=122&end=127"},
    { id: 39,
      quote: "Hello. My name is Inigo Montoya. You killed my father. Prepare to die" ,
      title: "",
      video: "https://www.youtube.com/watch?v=-3lKbMBab18?start=37&end=45"},
    { id: 40,
      quote: "The first rule of Fight Club is: You do not talk about Fight Club.",
      title: "",
      video: "https://www.youtube.com/watch?v=dC1yHLp9bWA?start=13&end=17"},
    { id: 41,
      quote: "Of all the gin joints in all the towns in all the world, she walks into mine." ,
      title: "",
      video: "https://www.youtube.com/watch?v=Qa8d-jwFwds?start124&end=130"},
    { id: 42,
      quote: "I'm going to make him an offer he can't refuse" ,
      title: "",
      video: "https://youtu.be/SeldwfOwuL8?start=12&end=14"},
    { id: 43,
      quote: "May the Force be with you" ,
      title: "",
      video: "https://youtu.be/VGd6bqTpEAk?start=4&end=6"},
    { id: 44,
      quote: "Frankly, my dear, I don't give a damn" ,
      title: "",
      video: "https://youtu.be/xLnTWxpTQt4?start=14&end=16"},
    { id: 45,
      quote: "Some people can’t believe in themselves until someone else believes in them first." ,
      title: "Good will hunting",
      video: ""},
    { id: 46,
      quote: "It’s only after we’ve lost everything that we’re free to do anything" ,
      title: "",
      video: "https://youtu.be/pzJOduVHxoQ?start=204&end=208"},
    { id: 47,
      quote: "It is not our abilities that show what we truly are… it is our choices" ,
      title: "",
      video: "https://youtu.be/GC7Aqc-h9no?start27&end=33"},
    { id: 48,
      quote: "Why are you trying so hard to fit in when you were born to stand out?" ,
      title: "",
      video: "https://youtu.be/vVPtQKHiWwM?start=154&end=158"},
    { id: 49,
      quote: "The greatest thing you’ll ever learn is just to love and be loved in return" ,
      title: "",
      video: "https://youtu.be/5iC7_1e0IBI?start=1&end=24"},
    { id: 50,
      quote: "Life moves pretty fast. If you don’t stop and look around once in a while, you could miss it" ,
      title: "",
      video: "https://youtu.be/vsYBtfQ3QDo?start=9&end=15"},
    { id: 51,
      quote: "You’re nothing to me until you’re everything" ,
      title: "",
      video: "https://youtu.be/4O8eRVn7lgk?start=100&end=102"},
    { id: 52,
      quote: "The truth is a matter of circumstances, it’s not all things to all people all the time" ,
      title: "",
      video: "https://youtu.be/Nf7DwNE9jWE?start=55&end=59"},
    { id: 53,
      quote: "I believe whatever doesn’t kill you, simply makes you…stranger" ,
      title: "",
      video: "https://youtu.be/c_LGhj958Bw?start=21&end=28"},
    { id: 54,
      quote: "Man is least himself when he talks in his own person. But if you give him a mask, he will tell you the truth" ,
      title: "",
      video: "https://youtu.be/wY2vhSb3cVo?start=32&end=40"},
    { id: 55,
      quote: "All those moments will be lost in time… like tears in rain" ,
      title: "",
      video: "https://www.youtube.com/watch?v=NoAzpa1x7jU"},
    { id: 56,
      quote: "To call you stupid would be an insult to stupid people" ,
      title: "",
      video: "https://www.youtube.com/watch?v=2j3adcbEwSM"},
    { id: 57,
      quote: "We all want to help one another. Human beings are like that. We want to live by each other’s happiness, not by each other’s misery" ,
      title: "",
      video: "https://www.youtube.com/watch?v=wMKpYxhI2KI"},
    { id: 58,
      quote: "True love cannot be found where it doesn’t exist, nor can it be hidden where it truly does - " ,
      title: "Kissing a fool",
      video: "https://youtu.be/Nza0REJ13qI?t=34"},
    { id: 59,
      quote: "Don’t let anyone ever make you feel like you don’t deserve what you want." ,
      title: "",
      video: "https://www.youtube.com/watch?v=pestpidO3zA"},
    { id: 60,
      quote: "I don’t regret the things I’ve done, but those I did not do " ,
      title: "empire records",
      video: ""},
    { id: 61,
      quote: "All we have to decide is what to do with the time that is given to us" ,
      title: "",
      video: "https://www.youtube.com/watch?v=IrOqnZdvI6M"},
    { id: 62,
      quote: "Great men are not born great, they grow great. " ,
      title: "The Godfather",
      video: ""},
    { id: 63,
      quote: "Just keep swimming. Just keep swimming. Just keep swimming, swimming, swimming. What do we do? We swim, swim." ,
      title: "",
      video: "https://www.youtube.com/watch?v=jRPjLLuF27k"},
    { id: 64,
      quote: "Dying for the right cause. It’s the most human thing we can do" ,
      title: "",
      video: "https://youtu.be/KCyivZ__64A?start=120&end=126"},
    { id: 65,
      quote: "How many times do I have to teach you: just because something works doesn’t mean it can’t be improved " ,
      title: "Black Panther",
      video: ""}, 
    { id: 66,
      quote: "That’s one small step for man, one giant leap for mankind" ,
      title: "",
      video: "https://www.youtube.com/watch?v=YFx1Dz0e1wc"},
    { id: 67,
      quote: "You talking to me? Well, then who the Hell else are you talking? You talking to me? Well, I'm the only one here." ,
      title: "",
      video: "https://www.youtube.com/watch?v=4e9CkhBb18E"}]; 

export const behaviors = [
    { id: 1, behavior: "Emotion = neutral, Confidence = confident"},
    { id: 2, behavior: "Politeness = polite, Extroversion = shy"},
    { id: 3, behavior: "Politeness = polite, Extroversion = extrovert"},
    { id: 4, behavior: "Speaking rate = slow"},
    { id: 5, behavior: "Speaking rate = fast"},
    { id: 6, behavior: "Emotion = sad"},
    { id: 7, behavior: "Emotion = anger"},
    { id: 8, behavior: "Confidence = confident"},
    { id: 9, behavior: "Confidence = non-confident"},
    { id: 10, behavior: "Emotion = anger, politeness = rude"},
    { id: 11, behavior: "Emotion = anger, politeness = polite"},
    { id: 12, behavior: "Speaking rate = slow, Vocal variety = monotonous"},
    { id: 13, behavior: "Speaking rate = slow, Vocal variety = expressive"},
    { id: 14, behavior: "Speaking rate = fast, Vocal variety = monotonous"},
    { id: 15, behavior: "Speaking rate = fast, Vocal variety = expressive"}];

export const stories = [
    { id: 1,
      quote: "Πείτε μου τι συνέβη όταν πάθατε το εγκεφαλικό." ,
      title: "stroke",
      video: "https://www.youtube.com/watch?v=3PzY_ro13UE"},
    { id: 2,
      quote: "Κοιτάξτε πρώτα όλες τις εικόνες με τη σειρά. Μετά πείτε μου τι συμβαίνει σε αυτές σαν μια ιστορία με αρχή, μέση και τέλος." ,
      title: "party",
      video: "https://www.youtube.com/embed/J4fjA8W-6es?start=20&end=27"},
    { id: 3,
      quote: "Θα σκούσετε μια ιστορία για το τι συμβαίνει σε αυτές τις εικόνες. Μόλις τελειώσει θα πρέπει να την επαναλάβετε όσο το δυνατόν πιο ολοκληρωμένα. Κοιτάξτε πρώτα τις εικόνες." ,
      title: "ring",
      video: "https://www.youtube.com/watch?v=Ft7wEehEMdo"},
    { id: 4,
      quote: "Θα ακούσετε μια ιστορία. Ακούστε την προσεκτικά και μόλις τελειώσει θα πρέπει να την επαναλάβετε όσο το δυνατόν πιο ολοκληρωμένα." ,
      title: "rabbit",
      video: "https://youtu.be/E_qvy82U4RE?t=51s"}];

export const SentencesContext = React.createContext(
    {}
);

